// utils/emailValidator.js
import { getFirestore, collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { auth } from '../firebase';

const firestore = getFirestore();

export const checkEmailInAllCollections = async (email) => {
  const foundAccounts = [];

  try {
    // Check 1: Investment/Trading users
    const investmentQuery = query(
      collection(firestore, "UserRegistrations"), 
      where("email", "==", email)
    );
    const investmentSnapshot = await getDocs(investmentQuery);
    
    if (!investmentSnapshot.empty) {
      foundAccounts.push({
        type: 'investment',
        collection: 'UserRegistrations',
        data: investmentSnapshot.docs[0].data(),
        id: investmentSnapshot.docs[0].id
      });
    }

    // Check 2: Training program users
    const trainingQuery = query(
      collection(firestore, "FormRegistration"), 
      where("emailAddress", "==", email)
    );
    const trainingSnapshot = await getDocs(trainingQuery);
    
    if (!trainingSnapshot.empty) {
      foundAccounts.push({
        type: 'training',
        collection: 'FormRegistration',
        data: trainingSnapshot.docs[0].data(),
        id: trainingSnapshot.docs[0].id
      });
    }

    // Check 3: General investors
    const currentUser = auth.currentUser;
    if (currentUser) {
      const investorDoc = doc(firestore, "Investors", currentUser.uid);
      const investorSnap = await getDoc(investorDoc);
      
      if (investorSnap.exists()) {
        foundAccounts.push({
          type: 'general',
          collection: 'Investors',
          data: investorSnap.data(),
          id: investorSnap.id
        });
      }
    }

    return foundAccounts;
  } catch (error) {
    console.error("Error checking email across collections:", error);
    return [];
  }
};